import { useAuth } from '@simplifi/auth'

export function hasConfigAccess(): boolean {
  const auth = useAuth()
  return (
    auth.hasPermission('Operations.ConfigureShortCodes' as never) ||
    auth.hasPermission('Operations.ConfigureWorkstreamTimers' as never)
  )
}

export function hasTranscriptionAccess(): boolean {
  return useAuth().hasPermission('Operations.TranscribeCallRecordings' as never)
}

export function hasSetContinuityStateAccess(): boolean {
  return useAuth().hasPermission(
    'Operations.SetContinuityServiceState' as never,
  )
}

export function hasMessagingAccess(): boolean {
  return useAuth().hasPermission('Operations.MercuriAccess' as never)
}

export function hasMessagingAdminAccess(): boolean {
  return useAuth().hasPermission('Operations.MercuriAdmin' as never)
}
